import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailValidator(): ValidatorFn {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value || emailRegex.test(value)) {
      return null;
    }
    return { invalidEmail: true };
  };
}

export function invalidValuesValidator(invalidValues: any[] = [null, '', 0, '0']): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // Si el valor está en la lista de valores inválidos (estricta o por coerción)
    if (invalidValues.some(v => v === value || String(v) === String(value))) {
      return { invalidValue: true };
    }

    return null;
  };
}

export function importeMayorACeroValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = parseFloat(control.value?.toString().replace(/[$,]/g, '') || '0');
    return value > 0 ? null : { importeInvalido: true };
  };
}

export function importeMayorASumAsegValidator(suma): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = parseFloat(control.value?.toString().replace(/[$,]/g, '') || '0');
    const sumaAseg = parseFloat(suma?.toString().replace(/[$,]/g, '') || '0');
    if (sumaAseg == 0) return null
    return value > sumaAseg ? { sumaAsegurada: true } : null;
  };
}
